import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { getMegaMenuData } from '../../megaMenuData';
import css from './MegaMenu.module.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const MegaMenu = ({ lang }) => {
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const data = getMegaMenuData(lang);
  const history = useHistory();
  const isGreekLanguage = lang === 'el';
  const handleMenuItemClick = (mainUrl, key) => {
    const isSearchPage = mainUrl.startsWith('/s');
    if (isSearchPage) {
      history.push(`${mainUrl}`);
    } else {
      history.push(`${mainUrl}`);
    }
    setOpenSubMenu(null); // Close submenu when an option is clicked
  };
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1200);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className={css.menuContainer}>
      <div className={css.main}>
        {data.map((item, index) => {
          const { main, column = [], clickable, hoverable, image, url } = item;
          const isSaleMenuItem = main?.url === '/sale26';
          const menuItemClassName = classNames(css.menuItem, {
            [css.saleMenuItem]: isSaleMenuItem,
          });
          const labelClassName = classNames(css.label, {
            [css.saleLabel]: isSaleMenuItem,
          });

          return (
            <div
              key={index}
              className={menuItemClassName}
              onMouseEnter={() => setOpenSubMenu(main.label)}
            >
              {clickable ? (
                <div onClick={() => handleMenuItemClick(main.url)} className={labelClassName}>
                  {main.label}
                </div>
              ) : (
                <div className={labelClassName}>{main.label}</div>
              )}
              {hoverable && openSubMenu === main.label ? (
                <div
                  style={
                    index >= data.length / 2
                      ? { right: 0, left: 'auto' }
                      : isSmallScreen && index < data?.length - 1
                        ? { left: `${index * -((50 * index) / 3)}px` }
                        : {}
                  }
                  className={image?.imageUrl || image?.elImageUrl ? css.submenu : css.subMenuSingle}
                >
                  <div className={css.subMenuLeft}>
                    {/* <h4 className={css.subMenuTitle}>{main.label?.toLowerCase()}</h4> */}
                    <div className={css.columns}>
                      {column?.map((col, index) => {
                        const { title, sub } = col;

                        return (
                          <div key={index} className={css.column}>
                            <h4 className={css.subMenuTitle}>{title?.toLowerCase()}</h4>
                            {/* <h4 className={css.columnTitle}>{title}</h4> */}
                            <ul className={sub?.length > 10 ? css.ulGreater : css.ul}>
                              {sub?.map((subItem, i) => {
                                return (
                                  <li key={i} className={css.li}>
                                    <div
                                      className={css.optionLabel}
                                      onClick={() => {
                                        if (subItem?.url.startsWith('/s')) {
                                          history.push(`${subItem?.url}`);
                                        } else {
                                          history.push(`${subItem?.url}`);
                                        }

                                        setOpenSubMenu(null); // Close submenu when an option is clicked
                                      }}
                                    >
                                      {subItem.label}
                                    </div>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  {image && (
                    <div className={css.subMenuRight}>
                      <img
                        src={
                          isGreekLanguage
                            ? image?.elImageUrl
                              ? image?.elImageUrl
                              : image?.imageUrl
                            : image?.imageUrl
                        }
                        alt={main.label}
                        onClick={() => {
                          if (image?.url) handleMenuItemClick(image?.url);
                        }}
                        style={{
                          cursor: 'pointer',
                          height: image.height ? image.height : '100%',
                          width: image.width ? image.width : '100%',
                        }}
                      />
                    </div>
                  )}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MegaMenu;
